import api from './api';
import { API_COMMANDS } from './commands';

// Функция для создания ASN через POST-запрос //test
const createAsn = async (asnData) => {
  const response = await api.post('', asnData, {
    params: { command: API_COMMANDS.ASN_CREATE_OR_CANCEL },
  });
  return response.data;
};

const createOrder = async (orderData) => {
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.ORDER_CREATE },
  });
  return response.data;
};

const getOrders = async (params = {}) => {
  const orderData = {
    // page_size: 40,
    // page: 1,
    ...params,
  };
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.ORDER_LIST },
  });
  console.log(response);
  return response.data;
};

// Параметры дублируются в query и в JSON-тело: delete_file.md пишет, что
// они читаются "из query/form" (так их передаёт addFileToOrder), но в теле
// они работали исторически. Лишние поля безвредны, а так запрос точно
// доходит независимо от того, откуда бэкенд их читает.
// Флаг asn здесь СОЗНАТЕЛЬНО не передаётся: по словам разработчика бэкенда
// файлы ASN редактируются так же, как файлы обычных заказов.
// order_no/asn передаются по аналогии с add_file_to_order, где файл
// идентифицируется парой (номер документа + признак ASN). Если бэкенду
// они не нужны - лишние параметры безвредны. asn отправляется ТОЛЬКО
// когда true: строка "false" в query на многих бэкендах истинна.
// Поля запроса передаются ТОЛЬКО в теле, в query уходит один command -
// именно так работает удаление/изменение файлов у обычных заказов, и по
// подтверждению разработчика бэкенда для ASN всё точно так же.
//
// Что было не так раньше: я добавлял file_ref/order_no/asn ещё и в query.
// Из-за order_no бэкенд шёл искать ЗАКАЗ с этим номером, а номер был от
// ASN - отсюда "Файл не найден!". Никаких доп. параметров тут не нужно:
// файл однозначно определяется одним file_ref.
const deleteFile = async (orderData) => {
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.FILE_DELETE },
  });
  return response.data;
};

const changeFile = async (orderData) => {
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.FILE_EDIT_COPIES },
  });
  return response.data;
};

const addFileToOrder = async ({
  file,
  order_no,
  copies_count = 1,
  sticker = false,
  asn = false,
}) => {
  console.log(file);
  const formData = new FormData();

  formData.append('file', file); // 🔥 важно: 'file', не 'files'
  console.log(formData.get('file'));
  const response = await api.post('', formData, {
    params: {
      command: API_COMMANDS.FILE_ADD_TO_ORDER,
      order_no,
      copies_count,
      sticker,
      asn,
    },
  });

  return response.data;
};

const getCards = async (params = {}) => {
  const response = await api.get('', {
    params: {
      command: API_COMMANDS.PAYMENT_METHODS,
      ...params, // добавляем переданные параметры, если есть
    },
  });
  return response.data;
};

const getOwnerBalance = async (params) => {
  const response = await api.get('', {
    params: {
      command: API_COMMANDS.OWNER_BALANCE,
      ...params,
    },
  });
  return response.data;
};

const getAvailableDates = async (params) => {
  const response = await api.get('', {
    params: {
      command: API_COMMANDS.AVAILABLE_DATES,
      ...params,
    },
  });
  return response.data;
};

const makePaymentBill = async (orderData) => {
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.PAYMENT_BILL },
  });
  return response.data;
};

const makePaymentSBP = async (orderData) => {
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.PAYMENT_SBP },
  });
  return response.data;
};

const deleteUser = async () => {
  const response = await api.post(
    '',
    {},
    {
      params: { command: API_COMMANDS.USER_DELETE },
    }
  );
  return response.data;
};

const getTransactions = async (params) => {
  const response = await api.get('', {
    params: {
      command: API_COMMANDS.PAYMENT_TRANSACTIONS,
      ...params,
    },
  });
  console.log('выполнение запроса для истории платежей', response);
  return response.data;
};

const chooseDefaultPay = async (data) => {
  const response = await api.post('', data, {
    params: { command: API_COMMANDS.PAYMENT_CHOOSE_DEFAULT },
  });
  return response.data;
};

const payAllServices = async (data) => {
  const response = await api.post('', data, {
    params: { command: API_COMMANDS.PAYMENT_PAY_ALL_SERVICES },
  });
  return response.data;
};

const removePay = async (data) => {
  const response = await api.post('', data, {
    params: { command: API_COMMANDS.PAYMENT_DELETE },
  });
  return response.data;
};

const updateOrder = async (params = {}) => {
  const orderData = {
    page_size: 20,
    page: 1,
    ...params,
  };
  const response = await api.post('', orderData, {
    params: { command: API_COMMANDS.ORDER_CREATE },
  });
  return response.data;
};

// Функция для получения списка ASN
const fetchAsns = async (data) => {
  // const orderData = { page_size: 20, page: 1 };
  const response = await api.post(
    '',
    { ...data },
    {
      params: { command: API_COMMANDS.ASN_LIST },
    }
  );
  return response.data;
};

// Функция для отмены ASN
const cancelAsn = async (data) => {
  const response = await api.post('', data, {
    params: { command: API_COMMANDS.ASN_CREATE_OR_CANCEL },
  });
  return response.data;
};

const addAddress = async (data) => {
  const response = await api.post('', data, {
    params: { command: API_COMMANDS.ADDRESS_ADD },
  });
  return response.data;
};

const deleteAddress = async (data) => {
  const response = await api.post('', data, {
    params: { command: API_COMMANDS.ADDRESS_DELETE },
  });
  return response.data;
};

const havedebit = async () => {
  const response = await api.get('', {
    params: {
      command: API_COMMANDS.HAVE_DEBIT,
    },
  });
  console.log('выполнение запроса для поиска задолженности', response);
  return response.data?.result ?? null;
};
const getAddresses = async () => {
  const response = await api.get('', {
    params: {
      command: API_COMMANDS.ADDRESS_LIST,
    },
  });
  console.log(response);
  return response.data?.addresses ?? [];
};

export {
  addAddress,
  addFileToOrder,
  cancelAsn,
  changeFile,
  chooseDefaultPay,
  createAsn,
  createOrder,
  deleteAddress,
  deleteFile,
  deleteUser,
  fetchAsns,
  getAddresses,
  getAvailableDates,
  getCards,
  getOrders,
  getOwnerBalance,
  getTransactions,
  havedebit,
  makePaymentBill,
  makePaymentSBP,
  payAllServices,
  removePay,
  updateOrder,
};
